// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iaWU","colBig":"styles_colBig__3Gmd6","colSmall":"styles_colSmall__GPMe3"};